export const PAGE_TITLE = 'Juki';
